import { render, staticRenderFns } from "./vcUploadFiles.vue?vue&type=template&id=2cc6b31a&scoped=true&"
import script from "./vcUploadFiles.vue?vue&type=script&lang=js&"
export * from "./vcUploadFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6b31a",
  null
  
)

export default component.exports